import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error?: Error;
}

/**
 * Reactエラーバウンダリコンポーネント
 * 子コンポーネントでエラーが発生した際のフォールバック表示を提供
 */
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    // カスタムエラーハンドラーがあれば実行
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // カスタムフォールバックがあれば使用
      if (this.props.fallback) {
        return this.props.fallback;
      }

      // デフォルトエラー表示
      return (
        <div className="container-fluid py-5">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <div className="alert alert-danger" role="alert">
                <h4 className="alert-heading">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  エラーが発生しました
                </h4>
                <p className="mb-3">
                  申し訳ございませんが、予期しないエラーが発生しました。
                  ページを再読み込みしてもう一度お試しください。
                </p>
                <hr />
                <button 
                  className="btn btn-outline-danger"
                  onClick={() => window.location.reload()}
                >
                  ページを再読み込み
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 